import { NAVIGATION_RECEIVE } from "../Actions/Navigation.action"

export const menu = (state = { menuItems: [] }, action) => {
    switch (action.type) {
        case NAVIGATION_RECEIVE:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state
    }
}
